import { render, staticRenderFns } from "./select.vue?vue&type=template&id=3cbfb7f6&scoped=true"
import script from "./select.js?vue&type=script&lang=js&external"
export * from "./select.js?vue&type=script&lang=js&external"
import style0 from "./select.scss?vue&type=style&index=0&id=3cbfb7f6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbfb7f6",
  null
  
)

export default component.exports